import { createStore, createHook } from '@atlassian/react-sweet-state';
import actions from './actions';
import { initialState } from './constants';
import type { State } from './types';

export { RetroTypes, type RetroType } from './types';

type Actions = typeof actions;

export const Store = createStore<State, Actions>({ initialState, actions, name: 'create-retros' });

export const useRetros = createHook(Store);
